import { render, staticRenderFns } from "./FilterSuggestionsModal.vue?vue&type=template&id=03951e5a&scoped=true"
import script from "./FilterSuggestionsModal.vue?vue&type=script&lang=js"
export * from "./FilterSuggestionsModal.vue?vue&type=script&lang=js"
import style0 from "./FilterSuggestionsModal.vue?vue&type=style&index=0&id=03951e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03951e5a",
  null
  
)

export default component.exports